import { createApi } from '@reduxjs/toolkit/query/react'
import { MANAGE_EXPORT_CREATE, MANAGE_EXPORT_LIST, MANAGE_EXPORT_REGENERATE } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const exportApi = createApi({
    reducerPath: 'exportApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/export",
    }),
    tagTypes: ["ExportList"],
    endpoints: (builder) => ({

        // get export list
        getExportList: builder.query({
            query: ({ status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MANAGE_EXPORT_LIST,
                data: { status, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ExportList"]
        }),

        // Regenerate Export
        regenerateExport: builder.mutation({
            query: (id) => ({
                method: "GET",
                url: `${MANAGE_EXPORT_REGENERATE}/${id}`
            }),
            invalidatesTags: ["ExportList"]
        }),

        // Regenerate Export
        createExport: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MANAGE_EXPORT_CREATE,
                data
            }),
            invalidatesTags: ["ExportList"]
        }),
    }),
})

export const {
    useGetExportListQuery,
    useRegenerateExportMutation,
    useCreateExportMutation

} = exportApi;